<template>
<div>
  <p style="white-space: pre-line;text-align: left;padding: 10px;">
    <stong>如何提现？</stong>
    在满足提现条件的情况下，绑定实名制微信号就可以提现到微信钱包。同时您也可以通过玩游戏、做任务和观看视频等方式加速收益。
    <stong>提现没有到账怎么办？</stong>
    在提现申请人数较多的情况下，需要3-5个工作日的审核时间，请您耐心等待。如果需要更多帮助，可以通过下方的反馈入口跟我们的产品小助手沟通。
    <stong>提现为什么会失败？</stong>
    根据我们的用户服务协议，通过软件自动化行为、作弊行为获取金币的用户无法提现，邀请较多无效用户也可能造成无法提现。请您遵守规则，合理使用。如果您认为不属于以上情况，可以通过客服功能跟我们的产品小助手反馈您的问题。
    <stong>视频无法观看怎么办？</stong>
    一般情况下，视频观看不了可能是网络连接异常，或是当天的视频观看次数达到上限。您可以后台关闭app重新进入再进行尝试，或耐心等待至第二天。若仍然有问题，您可以把具体问题截屏，通过下方的反馈入口，反馈给我们的产品小助手。
    <stong>广告内容不当</stong>
    根据我们的用户服务协议，本产品可能会添加第三方广告，我们不对第三方提供的服务与内容的安全性、准确性、有效性及其他不确定问题负责。请您在观看第三方广告时注意甄别，同时也非常欢迎您通过意见反馈入口向我们举报。
    <stong>广告卡住或黑屏</stong>
    抱歉给您带来不便，由于设备、系统和网络的复杂性，广告卡住或黑屏的原因很多，您可以尝试退出广告页面重新进入，或到应用商店更新至最新版本。若仍无法解决，请将您的用户信息与广告卡住页面截图，通过下方的反馈入口，发送给我们。用户信息查询方法：点击底部“我的” → 将打开的界面截图即可。
    <stong>对广告推荐感到打扰</stong>
    很多广告推荐的游戏或软件也比较有趣味性，您如果感兴趣，也可以尝试点击下载试玩；如果没有兴趣，点击叉号关闭即可。若某个特定广告使您感到不适，欢迎反馈给我们。祝您使用愉快！
    <stong>广告宣传与实际产品有差异</stong>
    根据我们的用户服务协议，本公司可基于运营策略对产品内各功能、活动的条件与规则做相关调整，请以最新实际规则为准。
    <stong>无法打开或进入软件</stong>
    抱歉给您带来不便，本产品需要连接网络才能进行，请您检查网络连接是否顺畅。若网络正常但仍无法进入，请稍等十分钟左右再次尝试，或请到应用商店更新至最新版本。若依然无法解决，可以截图通过意见反馈入口跟我们沟通。
    <stong>软件自动退出</stong>
    闪退问题或与您的设备系统、机型网络等有关。您可尝试到应用商店更新至最新版本。若依旧无法解决，可以截图通过意见反馈入口跟我们沟通。
  </p>
</div>
</template>

<script>
export default {
  name: "question"
}
</script>

<style scoped>

</style>